<div class="p-16">
    <mat-accordion class="addresses">
        <div *ngFor="let module of modules">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>{{module.name|translate}}</mat-panel-title>
                </mat-expansion-panel-header>

                <table class="simple">
                    <thead>
                    <tr>
                        <th></th>
                        <th *ngFor="let role of roles">{{role.name|translate}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let permission of permissions">
                        <th>{{permission.name|translate}}</th>
                        <td *ngFor="let role of roles" style="text-align: center;">
                            <button *ngIf="!assignedPermissions[module.id + role.id + permission.id]" (click)="updatePermission(module, role, permission, true)" type="button" mat-raised-button color="accent">{{'Allow'|translate}}</button>
                            <button *ngIf="assignedPermissions[module.id + role.id + permission.id]" (click)="updatePermission(module, role, permission, false)" type="button" mat-raised-button color="warn">{{'Disallow'|translate}}</button>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </mat-expansion-panel>
        </div>
    </mat-accordion>

</div>